<mat-card appearance="outlined">
  <mat-card-title name="filterHead" (click)="$event.stopPropagation()" class="pad10"> Filter By </mat-card-title>
  <mat-card-actions class="filterMennuActionBtn">
    <button mat-raised-button class="Icon-Btn-apply" (click)="applyFilter()">Apply</button>
    <span (click)="$event.stopPropagation()">
      <button mat-raised-button class="Icon-Btn-clear widhie38" (click)="clearFilter()">Clear All</button>
    </span>
  </mat-card-actions>
  <div *ngIf="!recLead">
    <div>
      <mat-accordion class="cus-accordion" (click)="$event.stopPropagation()">
        <mat-expansion-panel>
          <mat-expansion-panel-header name="reqIdHead"> Req ID </mat-expansion-panel-header>
          <div class="scroll-panel">
            <mat-form-field>
              <input
                matInput
                type="text"
                placeholder="Search Req ID"
                [formControl]="keyword"
                name="searchReqInput"
                (keyup)="searchReqId()"
                class="input_searchReq"
              />
            </mat-form-field>
            <div *ngFor="let reqId of reqIdDisplay">
              <mat-checkbox
                type="checkbox"
                [checked]="filteredRequisitionId.indexOf(reqId) !== -1"
                name="checkbox{{ reqId }}"
                (change)="checkReqId(reqId)"
              >
                {{ reqId }}
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div>
      <mat-accordion class="cus-accordion" (click)="$event.stopPropagation()">
        <mat-expansion-panel>
          <mat-expansion-panel-header name="reqTitleHead"> Req Title </mat-expansion-panel-header>
          <div class="scroll-panel">
            <mat-form-field>
              <input
                matInput
                type="text"
                placeholder="Search Req Title"
                [formControl]="keyword_title"
                name="searchReqTitleInput"
                (keyup)="searchReqTitle()"
                class="input_searchReq"
              />
            </mat-form-field>
            <div *ngFor="let reqTitle of reqTitleDisplay">
              <mat-checkbox
                type="checkbox"
                [checked]="filteredRequisitionTitle.indexOf(reqTitle) !== -1"
                name="checkbox{{ reqTitle }}"
                (change)="checkReqTitle(reqTitle)"
              >
                {{ reqTitle }}
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div *ngIf="selected === 'skill' || selected === 'S2H' || selected === 'S2RL'">
      <mat-accordion class="cus-accordion" (click)="$event.stopPropagation()">
        <mat-expansion-panel>
          <mat-expansion-panel-header name="locationhead"> Location </mat-expansion-panel-header>
          <div class="scroll-panel">
            <div *ngFor="let location of locationDisplay">
              <mat-checkbox
                type="checkbox"
                [checked]="filteredLocation.indexOf(location) !== -1"
                name="checkbox{{ location }}"
                (change)="checkLocation(location)"
              >
                {{ location }}
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div *ngIf="(selected === 'location' || selected === 'S2H' || selected === 'S2RL') && id != '2'">
      <mat-accordion class="cus-accordion" (click)="$event.stopPropagation()">
        <mat-expansion-panel>
          <mat-expansion-panel-header name="locationhead"> Skill </mat-expansion-panel-header>
          <div class="scroll-panel">
            <div *ngFor="let skill of skillDisplay">
              <mat-checkbox
                type="checkbox"
                [checked]="filteredSkill.indexOf(skill) !== -1"
                name="checkbox{{ skill }}"
                (change)="checkSkill(skill)"
              >
                <span class="wordWrap">{{ skill }}</span>
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div *ngIf="selected !== 'roles'">
      <mat-accordion class="cus-accordion" (click)="$event.stopPropagation()">
        <mat-expansion-panel>
          <mat-expansion-panel-header name="roleHead"> Role </mat-expansion-panel-header>
          <div class="scroll-panel">
            <div *ngFor="let role of roleDisplay">
              <mat-checkbox
                type="checkbox"
                [checked]="filteredRole.indexOf(role) !== -1"
                name="checkbox{{ role }}"
                (change)="checkRole(role)"
              >
                {{ role }}
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div *ngIf="selected !== 'S2H' && selected !== 'S2RL'">
      <mat-accordion class="cus-accordion" (click)="$event.stopPropagation()">
        <mat-expansion-panel>
          <mat-expansion-panel-header name="roleHead"> Due By </mat-expansion-panel-header>
          <div class="scroll-panel">
            <div *ngFor="let dueBy of dueDateDisplay">
              <mat-checkbox
                type="checkbox"
                [checked]="filteredDueDate.indexOf(dueBy) !== -1"
                name="checkbox{{ dueBy }}"
                (change)="checkDueDate(dueBy)"
              >
                {{ dueBy }}
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div>
      <mat-accordion class="cus-accordion" (click)="$event.stopPropagation()">
        <mat-expansion-panel>
          <mat-expansion-panel-header name="PU"> PU </mat-expansion-panel-header>
          <div class="scroll-panel">
            <div *ngFor="let pU of puDisplay">
              <mat-checkbox
                type="checkbox"
                [checked]="filteredPU.indexOf(pU) !== -1"
                name="checkbox{{ pU }}"
                (change)="checkPU(pU)"
              >
                {{ pU }}
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div *ngIf="selected !== 'S2H' && selected !== 'S2RL'">
      <mat-accordion class="cus-accordion" (click)="$event.stopPropagation()">
        <mat-expansion-panel>
          <mat-expansion-panel-header name="CreatedBy"> Created By </mat-expansion-panel-header>
          <div class="scroll-panel">
            <div *ngFor="let createdBy of createdByDisplay">
              <mat-checkbox
                type="checkbox"
                [checked]="filteredCreatedBy.indexOf(createdBy) !== -1"
                name="checkbox{{ createdBy }}"
                (change)="checkCreatedBy(createdBy)"
              >
                {{ createdBy }}
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div *ngIf="recLead">
    <div>
      <mat-accordion class="cus-accordion" (click)="$event.stopPropagation()">
        <mat-expansion-panel>
          <mat-expansion-panel-header name="requisitionId"> Requisition Id </mat-expansion-panel-header>
          <div class="scroll-panel">
            <div *ngFor="let requisitionId of requisitionIdDisplay">
              <mat-checkbox
                type="checkbox"
                [checked]="filteredReqId.indexOf(requisitionId) !== -1"
                name="chckbox{{ requisitionId }}"
                (change)="checkReqId1(requisitionId)"
              >
                {{ requisitionId }}
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div>
      <mat-accordion class="cus-accordion" (click)="$event.stopPropagation()">
        <mat-expansion-panel>
          <mat-expansion-panel-header name="PU"> PU </mat-expansion-panel-header>
          <div class="scroll-panel">
            <div *ngFor="let pU of puDisplay">
              <mat-checkbox
                type="checkbox"
                [checked]="filteredPU.indexOf(pU) !== -1"
                name="chckbox{{ pU }}"
                (change)="checkPU(pU)"
              >
                {{ pU }}
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div>
      <mat-accordion class="cus-accordion" (click)="$event.stopPropagation()">
        <mat-expansion-panel>
          <mat-expansion-panel-header name="requisitionIdHead"> Recruiter </mat-expansion-panel-header>
          <div class="scroll-panel">
            <input
              matInput
              type="text"
              placeholder="Search Recruiter"
              [formControl]="keyword"
              name="searchRequInput"
              (keyup)="searchRecruiterId()"
              class="input_searchReq"
            />
            <div *ngFor="let recId of recruiterDisplay">
              <mat-checkbox
                type="checkbox"
                [checked]="filteredRecruiter.indexOf(recId) !== -1"
                name="chckboxId{{ recId }}"
                (change)="checkRecruiterId(recId)"
              >
                {{ recId }}
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div *ngIf="selected !== 'roles'">
      <mat-accordion class="cus-accordion" (click)="$event.stopPropagation()">
        <mat-expansion-panel>
          <mat-expansion-panel-header name="rolesHead"> Role </mat-expansion-panel-header>
          <div class="scroll-panel">
            <div *ngFor="let role of roleDisplay">
              <mat-checkbox
                type="checkbox"
                [checked]="filteredRole.indexOf(role) !== -1"
                name="chekbox{{ role }}"
                (change)="checkRole(role)"
              >
                {{ role }}
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div>
      <mat-accordion class="cus-accordion" (click)="$event.stopPropagation()">
        <mat-expansion-panel>
          <mat-expansion-panel-header name="sourcenameHead"> Source </mat-expansion-panel-header>
          <div class="scroll-panel">
            <div *ngFor="let source of sourceDisplay">
              <mat-checkbox
                type="checkbox"
                [checked]="filteredSource.indexOf(source) !== -1"
                name="chkbox{{ source }}"
                (change)="checkSource(source)"
              >
                {{ source }}
              </mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</mat-card>
